<template>
  <AuthLayout>
    <template #header>
      <h1 class="text-[32px] font-semibold">Create an account</h1>
      <p class="text-strong text-xl -mt-2">Get up to 13% annual returns with Phoenix</p>
    </template>

    <div class="w-full">
      <!-- Form inputs -->
      <div class="flex flex-col w-full mb-8">
        <BaseInput
          v-model="authStore.signup_fields.email"
          label="Email address"
          field_name="email"
          field_type="string"
          place_holder="Enter your email"
          variant="secondary"
          is_required
          @keydown.enter="handleNextStep"
        />
        <div v-if="signup_error" class="mt-3 ml-3 font-inter text-error text-sm flex items-center">
          <Icon
            name="Asterisk"
            class="mr-2 h-[14px] w-[14px] min-w-[14px] -skew-x-12 stroke-error"
          />
          {{ signup_error }}
        </div>
      </div>
      <!-- CTA Buttons -->
      <div class="flex flex-col items-center w-full gap-2">
        <Button
          @click="handleNextStep"
          size="md"
          variant="always-secondary"
          class="w-full"
          @keydown.enter="handleNextStep"
        >
          <template #label>Create a new account</template>
        </Button>
        <p class="text-light font-inter">or</p>
        <Button @click="router.push('/sign-in')" size="sm" variant="primary-grey" class="w-full">
          <template #label>Already have an account? Sign in</template>
        </Button>
      </div>
      <!-- Turnstile widget -->
      <div class="mt-8" data-theme="light" id="turnstile"></div>
    </div>
  </AuthLayout>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import AuthLayout from "./AuthLayout.vue";

import { useAuthStore, useSchemaStore } from "@/stores";
import { useTurnstile } from "@/composables/useTurnstile";
import { useAnalytics } from "@/composables/useAnalytics";
import { BaseInput, Button, Icon } from "@/components";

const router = useRouter();
const authStore = useAuthStore();
const schemaStore = useSchemaStore();
const { signupStarted } = useAnalytics();

const signup_error = ref("");

const { resetTurnstile } = useTurnstile("turnstile", { persist: true });

onMounted(async () => {
  window.scrollTo(0, 0);
  schemaStore.show_input_errors = false;
  signupStarted();
});

const authSchema = [
  {
    field_name: "email",
    field_type: "string",
    is_required: true,
    label: "Email",
  },
];

function handleNextStep() {
  signup_error.value = "";
  const result = schemaStore.validateFields(
    { email: authStore.signup_fields.email },
    authSchema,
    null,
    true
  );

  if (!result.proceed) {
    return;
  }

  if (!authStore.is_turnstile_valid) {
    signup_error.value = "Please complete the security check to confirm that you are a human.";
    return;
  }

  authStore.is_signup = true;
  authStore.active_signup_step = 2;
  router.push("/sign-up/personal-details");
}
</script>
